import {
  AppBar as MuiAppBar,
  IconButton,
  styled,
  Toolbar,
  Typography,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import config from '../../config'
import awaA from '../../assets/a.png'
import awaAaa from '../../assets/aaa.svg'
import useIsMobile from '../../common/hooks/useIsMobile'
import AuthButton from '../../common/primitives/AuthButton'
import { colors } from '../../utils/colorUtils'

const underBarWidth = 12

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: '100%',
  height: `${config.mapAppBarHeight}px`,
  minHeight: `${config.mapAppBarHeight}px`,
  maxHeight: `${config.mapAppBarHeight}px`,
  borderBottom: `${underBarWidth}px solid ${colors.awaOffWhite}`,
}))

const AwaLogo = styled('img')(({ theme }) => ({
  marginRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  backgroundColor: colors.awaOffWhite,
  width: `auto`,
  height: `${config.mapAppBarHeight - underBarWidth}px`,
  [theme.breakpoints.up('sm')]: {
    marginBottom: `${underBarWidth - (config.mapAppBarHeight - 64)}px`,
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: `${underBarWidth - (config.mapAppBarHeight - 64) - 8}px`,
  },
}))

const Aaa = styled('img')(({ theme }) => ({
  paddingLeft: theme.spacing(25),
  height: `${config.mapAppBarHeight - underBarWidth}px`,
  width: 'auto',
  position: 'absolute',
  top: 0,
  zIndex: 1300,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(3),
  },
}))

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  marginLeft: theme.spacing(2.5),
  color: colors.awaCharcoal15,
  width: '400px',
}))

const MapAppBar = ({ appName, onClickMenu, appBarComponent }) => {
  const isMobile = useIsMobile()

  return (
    <StyledAppBar position="fixed">
      <Toolbar disableGutters>
        <a href="/" style={{ height: '100%' }}>
          <AwaLogo src={awaA} alt="Awa logo" />
        </a>
        {isMobile ? (
          <IconButton color="inherit" onClick={onClickMenu}>
            <MenuIcon />
          </IconButton>
        ) : (
          <a href="/navigator" style={{ textDecoration: 'none' }}>
            <Title variant="h1">{appName}</Title>
          </a>
        )}
        <div style={{ width: '100%' }}>
          <Aaa src={awaAaa} />
          {appBarComponent}
          <AuthButton sx={{ position: 'absolute', top: -2, right: 0 }} />
        </div>
      </Toolbar>
    </StyledAppBar>
  )
}

export default MapAppBar
